(() => {
  'use strict';

  const header = document.querySelector('.rv-main-header');
  const menuButton = document.querySelector('[data-rv-menu-toggle]');
  const primaryNav = document.querySelector('[data-rv-primary-nav]');
  const setMenuOpen = (open, returnFocus = false) => {
    if (!header || !menuButton || !primaryNav) return;
    header.dataset.menuOpen = open ? 'true' : 'false';
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const firstLink = primaryNav.querySelector('a');
      if (firstLink) firstLink.focus();
    } else if (returnFocus) {
      menuButton.focus();
    }
  };
  if (menuButton) {
    menuButton.addEventListener('click', () => setMenuOpen(menuButton.getAttribute('aria-expanded') !== 'true'));
    primaryNav.addEventListener('click', (event) => { if (event.target.closest('a')) setMenuOpen(false); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenuOpen(false, true); });
    window.addEventListener('resize', () => { if (window.innerWidth > 798) setMenuOpen(false); });
  }

  // Product descriptions are store data shared with the live theme, so correct the
  // preview-only rendering here instead of mutating the product record.
  const textReplacements = [
    [/618[.\s()-]*972[.\s-]*6737/g, '618.972.6736'],
    [/Technical\s*\/\s*Product Questions:/gi, 'Product Support:'],
    [/Sales\s*\/\s*Order Support:/gi, 'Order Support:'],
    [/Manufacturer\s+Owner\s*\/\s*Direct\s+Product[- ]Support\b/gi, 'Product Support'],
    [/SharkhideStore\s+Order\s+Support\b/gi, 'Order Support'],
  ];
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  for (const node of textNodes) {
    if (node.parentElement && /^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.parentElement.tagName)) continue;
    let value = node.nodeValue;
    for (const [pattern, replacement] of textReplacements) value = value.replace(pattern, replacement);
    if (value !== node.nodeValue) node.nodeValue = value;
  }
  for (const link of document.querySelectorAll('a[href^="tel:"]')) {
    if (/16189726737/.test(link.href.replace(/\D/g, ''))) link.setAttribute('href', 'tel:+16189726736');
  }

  // Keep the custom cart label synchronized with the hidden native header that
  // Parallax updates after its AJAX add-to-cart flow.
  const customCartLink = document.querySelector('[data-rv-cart-link]');
  const sourceCartCounts = [...document.querySelectorAll('.cart-button span')];
  const syncCartCount = () => {
    if (!customCartLink || !sourceCartCounts.length) return;
    const counts = sourceCartCounts.map((node) => Number.parseInt(node.textContent, 10)).filter(Number.isFinite);
    if (counts.length) customCartLink.textContent = `Cart (${Math.max(...counts)})`;
  };
  syncCartCount();
  for (const source of sourceCartCounts) {
    new MutationObserver(syncCartCount).observe(source, { childList: true, subtree: true, characterData: true });
  }

  const brokenPaths = new Set([
    '/pages/cybertruck-protection',
    '/products/cybertruck-protection-kit-complete-sharkhide-application-package'
  ]);
  for (const link of [...document.querySelectorAll('a[href]')]) {
    let target;
    try { target = new URL(link.href, location.origin); } catch (_) { continue; }
    if (target.origin !== location.origin || !brokenPaths.has(target.pathname.replace(/\/$/, ''))) continue;
    const span = document.createElement('span');
    span.className = `${link.className || ''} rv-dead-link-removed`.trim();
    span.innerHTML = link.innerHTML;
    span.setAttribute('title', 'This page is currently unavailable');
    span.setAttribute('aria-label', `${link.textContent.trim()} — currently unavailable`);
    span.dataset.removedBrokenHref = target.pathname;
    link.replaceWith(span);
  }

  const search = document.querySelector('[data-rv-faq-search]');
  if (search) {
    const items = [...document.querySelectorAll('[data-rv-faq-item]')];
    const groups = [...document.querySelectorAll('[data-rv-faq-group]')];
    const empty = document.querySelector('[data-rv-faq-empty]');
    const filter = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      for (const item of items) {
        const show = !query || item.textContent.toLowerCase().includes(query);
        item.hidden = !show;
        if (show) visible += 1;
      }
      for (const group of groups) group.hidden = ![...group.querySelectorAll('[data-rv-faq-item]')].some((item) => !item.hidden);
      if (empty) empty.style.display = visible ? 'none' : 'block';
    };
    search.addEventListener('input', filter);
  }
})();

